<div *transloco="let t" class="w-screen h-[100svh] bg-calm">
    @if(liveId){
        @if(currentType > 0 && !quizEnded && blockAnswers){
            <div>
        <div class="py-10">
            <img class="w-[70vw] animation-start-quiz-logo mx-auto" src="./assets/logo.png">
        </div>
        <div class="text-white text-[32px] leading-[38px] font-bold text-center px-5">{{t('answerReceived')}}</div>
    </div>
}
    @if(showTimer){
    <div class="h-[100dvh] w-screen flex items-center place-content-center">
        <div class="size-[200px] flex place-content-center items-center rounded-full border-[10px] border-white text-white font-bold text-[70px] animate-ping"
            id="timer-start">
            {{timerStart}}
        </div>
    </div>
    }
    @if(quizStatus == 1 && currentType == 0 && !showTimer){
    <div>
        <div class="py-10">
            <img class="w-[70vw] animation-start-quiz-logo mx-auto" src="./assets/logo.png">
        </div>
        <div class="text-white text-[32px] leading-[38px] font-bold text-center px-5">{{t('quizIsStarting')}}</div>
    </div>
    <app-cube_game></app-cube_game>
    }
    @if(quizStatus == 2 && currentType == 0){

    <div>
        <div class="py-10">
            <img class="w-[70vw] animation-start-quiz-logo mx-auto" src="./assets/logo.png">
        </div>
        @if(!isQuestionStopped){
            <div class="text-white text-[32px] leading-[38px] font-bold text-center px-5">{{t('waitingNextQuestion')}}</div>
        }
        @if(showRank() && yourRank.position){<div class="text-white text-[32px] font-bold text-center px-5">
            {{t('yourRank')}}</div>}
    </div>
    @if(showRank() && yourRank.position){<div
        class="mt-5 pr-5 overflow-hidden mx-auto w-[calc(100%-20px)] rounded-md border-black items-center h-[200px] flex bg-white">
        <div
            class="text-white px-2 font-bold flex items-center bg-blue-600 bg-opacity-15 text-[34px] min-w-[75px] h-full border-r-white border-r-2 text-center">
            <div class="h-fit mx-auto">
                <div class="mx-auto w-fit text-[46px] font-bold"
                    [ngClass]="{'!text-[34px]': yourRank.position > 99 && yourRank.position < 1000,'!text-[28px]': yourRank.position >= 1000 && yourRank.position < 10000,'!text-[20px]': yourRank.position >= 10000}">
                    {{yourRank.position}}°</div>
                @if(yourRank.position < 4){ <div class="flex size-[60px] mx-auto gap-2 pt-2 items-center">
                    <svg width="60px" height="60px"
                        [ngClass]="{'fill-yellow-400': yourRank.position == 1,'fill-gray-400': yourRank.position == 2,'fill-amber-800': yourRank.position == 3}"
                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                        <path
                            d="M320.3 192L235.7 51.1C229.2 40.3 215.6 36.4 204.4 42L117.8 85.3C105.9 91.2 101.1 105.6 107 117.5L176.6 256.6C146.5 290.5 128.3 335.1 128.3 384C128.3 490 214.3 576 320.3 576C426.3 576 512.3 490 512.3 384C512.3 335.1 494 290.5 464 256.6L533.6 117.5C539.5 105.6 534.7 91.2 522.9 85.3L436.2 41.9C425 36.3 411.3 40.3 404.9 51L320.3 192zM351.1 334.5C352.5 337.3 355.1 339.2 358.1 339.6L408.2 346.9C415.9 348 418.9 357.4 413.4 362.9L377.1 398.3C374.9 400.5 373.9 403.5 374.4 406.6L383 456.5C384.3 464.1 376.3 470 369.4 466.4L324.6 442.8C321.9 441.4 318.6 441.4 315.9 442.8L271.1 466.4C264.2 470 256.2 464.2 257.5 456.5L266.1 406.6C266.6 403.6 265.6 400.5 263.4 398.3L227.1 362.9C221.5 357.5 224.6 348.1 232.3 346.9L282.4 339.6C285.4 339.2 288.1 337.2 289.4 334.5L311.8 289.1C315.2 282.1 325.1 282.1 328.6 289.1L351 334.5z" />
                    </svg>
            </div>
            }
        </div>
    </div>
    <div class="flex gap-2 px-2 ml-2 items-center border-r-white border-r-2 h-full">
        <div class="text-[44px] bg-blue-600 bg-opacity-15 size-[85px] flex items-center place-content-center rounded-full">
            {{user.profile_icon}}</div>
        <!-- <div class="text-white font-bold text-[24px] w-[125px] overflow-hidden text-ellipsis">{{user.nickname}}</div> -->
    </div>
    <div class="text-blue-400 text-center font-bold ml-auto text-[18px]" [ngClass]="{'!text-[14px]': yourRank.score > 999}">
        <div class="text-[24px]">{{t('score')}}</div>
        <div class="font-bold text-[66px] leading-[68px]">{{yourRank.score}}</div>
    </div>
    </div>}
    }
    @if(quizStatus == 4 && currentType == 0){
    <div>
        <div class="py-10">
            <img class="w-[70vw] animation-start-quiz-logo mx-auto" src="./assets/logo.png">
        </div>
        <div style="white-space: pre-line;" class="text-white text-[32px] leading-[38px] font-bold text-center px-5">
            {{t('quizEnded')}}</div>
    </div>
    @if(showRank() && yourRank.position){
    @if(quizStatus == 4 && currentType == 0){
    <div (click)="exitQuiz()"
        class="fixed top-2 left-2 bg-white rounded-full size-[50px] flex items-center place-content-center"><svg
            width="40px" height="40px" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"><!--!Font Awesome Free v7.3.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.-->
            <path
                d="M569 337C578.4 327.6 578.4 312.4 569 303.1L425 159C418.1 152.1 407.8 150.1 398.8 153.8C389.8 157.5 384 166.3 384 176L384 256L272 256C245.5 256 224 277.5 224 304L224 336C224 362.5 245.5 384 272 384L384 384L384 464C384 473.7 389.8 482.5 398.8 486.2C407.8 489.9 418.1 487.9 425 481L569 337zM224 160C241.7 160 256 145.7 256 128C256 110.3 241.7 96 224 96L160 96C107 96 64 139 64 192L64 448C64 501 107 544 160 544L224 544C241.7 544 256 529.7 256 512C256 494.3 241.7 480 224 480L160 480C142.3 480 128 465.7 128 448L128 192C128 174.3 142.3 160 160 160L224 160z" />
        </svg></div>
    }
    <div
        class="mt-5 pr-5 overflow-hidden mx-auto w-[calc(100%-20px)] rounded-md border-black items-center h-[200px] flex bg-white">
        <div
            class="text-white px-2 font-bold flex items-center bg-blue-600 bg-opacity-15 text-[34px] min-w-[75px] h-full border-r-white border-r-2 text-center">
            <div class="h-fit mx-auto">
                <div class="mx-auto w-fit text-[46px] font-bold"
                    [ngClass]="{'!text-[34px]': yourRank.position > 99 && yourRank.position < 1000,'!text-[28px]': yourRank.position >= 1000 && yourRank.position < 10000,'!text-[20px]': yourRank.position >= 10000}">
                    {{yourRank.position}}°</div>
                @if(yourRank.position < 4){ <div class="flex size-[60px] mx-auto gap-2 pt-2 items-center">
                    <svg width="60px" height="60px"
                        [ngClass]="{'fill-yellow-400': yourRank.position == 1,'fill-gray-400': yourRank.position == 2,'fill-amber-800': yourRank.position == 3}"
                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                        <path
                            d="M320.3 192L235.7 51.1C229.2 40.3 215.6 36.4 204.4 42L117.8 85.3C105.9 91.2 101.1 105.6 107 117.5L176.6 256.6C146.5 290.5 128.3 335.1 128.3 384C128.3 490 214.3 576 320.3 576C426.3 576 512.3 490 512.3 384C512.3 335.1 494 290.5 464 256.6L533.6 117.5C539.5 105.6 534.7 91.2 522.9 85.3L436.2 41.9C425 36.3 411.3 40.3 404.9 51L320.3 192zM351.1 334.5C352.5 337.3 355.1 339.2 358.1 339.6L408.2 346.9C415.9 348 418.9 357.4 413.4 362.9L377.1 398.3C374.9 400.5 373.9 403.5 374.4 406.6L383 456.5C384.3 464.1 376.3 470 369.4 466.4L324.6 442.8C321.9 441.4 318.6 441.4 315.9 442.8L271.1 466.4C264.2 470 256.2 464.2 257.5 456.5L266.1 406.6C266.6 403.6 265.6 400.5 263.4 398.3L227.1 362.9C221.5 357.5 224.6 348.1 232.3 346.9L282.4 339.6C285.4 339.2 288.1 337.2 289.4 334.5L311.8 289.1C315.2 282.1 325.1 282.1 328.6 289.1L351 334.5z" />
                    </svg>
            </div>
            }
        </div>
    </div>
    <div class="flex gap-2 px-2 ml-2 items-center border-r-white border-r-2 h-full">
        <div class="text-[44px] bg-blue-600 bg-opacity-15 size-[85px] flex items-center place-content-center rounded-full">
            {{user.profile_icon}}</div>
        <!-- <div class="text-white font-bold text-[24px] w-[125px] overflow-hidden text-ellipsis">{{user.nickname}}</div> -->
    </div>
    <div class="text-blue-400 text-center font-bold ml-auto text-[18px]" [ngClass]="{'!text-[14px]': yourRank.score > 999}">
        <div class="text-[24px]">{{t('score')}}</div>
        <div class="font-bold text-[66px] leading-[68px]">{{yourRank.score}}</div>
    </div>
    </div>
    }
}
@if(currentType == 0 && !quizEnded && quizStatus == 1 && currentType == 0 && !showTimer){
<div [ngClass]="{'pointer-events-none opacity-35': isDisabledColor}"
    class="fixed w-[calc(100%-20px)] overflow-hidden h-[70px] bg-white flex rounded-xl border-[4px] left-[10px] bottom-[70px]">
    <div (click)="animationButton(0);testColorEmit('#2563eb')" [ngClass]="{'!animate-ping': testColorIndex === 0}"
        class="h-[68px] cursor-pointer w-[calc(25%)] bg-blue-600"></div>
    <div (click)="animationButton(1);testColorEmit('#ea580c')" [ngClass]="{'!animate-ping': testColorIndex === 1}"
        class="h-[68px] cursor-pointer w-[calc(25%)] bg-orange-600"></div>
    <div (click)="animationButton(2);testColorEmit('#16a34a')" [ngClass]="{'!animate-ping': testColorIndex === 2}"
        class="h-[68px] cursor-pointer w-[calc(25%)] bg-green-600"></div>
    <div (click)="animationButton(3);testColorEmit('#facc15')" [ngClass]="{'!animate-ping': testColorIndex === 3}"
        class="h-[68px] cursor-pointer w-[calc(25%)] bg-yellow-400"></div>
</div>
}
@if(currentType == 1 && !quizEnded && quizStatus != 4){
<div class="w-[calc(100%-20px)] mx-auto pt-2.5" [ngClass]="{'pointer-events-none hidden': blockAnswers}">
    @for (answer of answers; track $index) {
    @if(answer.option_text){<div (click)="animationButton($index);sendAnswer(answer.option_text)"
        [ngClass]="{'!animate-ping': testColorIndex === $index}"
        class="min-h-[68px] p-2 cursor-pointer w-full mb-5 text-white text-[18px] items-center place-content-center text-center rounded-xl"
        [style.background]="answer.color">
        {{answer.option_text}}</div>}
    }
</div>
}
@if(currentType == 2 && !quizEnded){
@if(showAnswersBuzzer){
<div class="w-[calc(100%-20px)] mx-auto pt-2.5" [ngClass]="{'pointer-events-none hidden': blockAnswers}">
    @for (answer of answers; track $index) {
    @if(answer.option_text){<div (click)="animationButton($index);sendAnswer(answer.option_text)"
        [ngClass]="{'!animate-ping': testColorIndex === $index}"
        class="min-h-[68px] p-2 cursor-pointer w-full mb-5 text-white text-[18px] items-center place-content-center text-center rounded-xl"
        [style.background]="answer.color">
        {{answer.option_text}}</div>}
    }
</div>

@if(!blockAnswers){<div class="text-white font-bold text-center w-fit mx-auto text-[42px] flex items-center gap-2">
    <div>{{timeBuzzer}}</div><svg height="50px" width="50px" xmlns="http://www.w3.org/2000/svg" fill="white"
        viewBox="0 0 640 640"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.-->
        <path
            d="M528 320C528 434.9 434.9 528 320 528C205.1 528 112 434.9 112 320C112 205.1 205.1 112 320 112C434.9 112 528 205.1 528 320zM64 320C64 461.4 178.6 576 320 576C461.4 576 576 461.4 576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320zM296 184L296 320C296 328 300 335.5 306.7 340L402.7 404C413.7 411.4 428.6 408.4 436 397.3C443.4 386.2 440.4 371.4 429.3 364L344 307.2L344 184C344 170.7 333.3 160 320 160C306.7 160 296 170.7 296 184z" />
    </svg>
</div>}
}@else{<div class="pt-[calc(50svh-125px)]" [ngClass]="{'pointer-events-none hidden': blockAnswers}">
    <!-- <div
                class="mx-auto bg-red-600 border-black border-[12px] rounded-full size-[250px]"></div> -->
    <div class="button-base mx-auto">
        <button class="red-button" (click)="reserveBuzzer()">
            <!-- FIRE -->
        </button>
    </div>
</div>}
}
@if(currentType == 3 && !quizEnded){
<div class="p-2 w-screen" [ngClass]="{'pointer-events-none hidden': blockAnswers}">
    <!-- <iframe class="pointer-events-none overflow-hidden rounded-lg h-[calc(100svh-66px)]" width="100%" frameborder="0" style="border:0" referrerpolicy="no-referrer-when-downgrade"
        src="https://www.google.com/maps/embed/v1/place?key=AIzaSyDtwMlFWSXSIH_xKcrgVN0dyU6_LdoUvxk&q=38.1481023,13.3461033,14.3"
        allowfullscreen>
    </iframe> -->
    <div class="flex w-fit mx-auto h-fit overflow-hidden rounded-xl">
        <google-map [height]="getHMap()" width="90vw" [zoom]="2" [options]="mapOptions" (mapClick)="onMapClick($event)">
            <map-marker *ngIf="answerToQuestion"
                [position]="{lat:toFloat(answerToQuestion.split(',')[0]),lng:toFloat(answerToQuestion.split(',')[1])}">
            </map-marker>
        </google-map>
    </div>
    <div [ngClass]="{'hidden': !answerToQuestion}" (click)="sendAnswer(answerToQuestion)"
        class="mt-2 text-center w-[90vw] mx-auto py-0.5 border-[2px] border-white rounded-full text-white text-[20px] font-semibold">
        {{t('modal.confirm')}}</div>
</div>
}
@if(currentType == 4 && !quizEnded){
<input [(ngModel)]="guessNumber" (keyup)="changeNumberGuess($event);"
    [ngClass]="{'pointer-events-none hidden': blockAnswers}"
    class="w-[calc(100%-20px)] ml-2.5 h-[50px] rounded-lg bg-blue-200 pointer-events-none mt-2.5 pl-2.5 text-[24px] font-semibold text-black" type="number">
<div class="flex flex-wrap px-2.5 gap-5 mt-5 w-fit mx-auto place-content-center max-w-[300px]"
    [ngClass]="{'pointer-events-none hidden': blockAnswers}">
    <div class="live-code-input-button" [ngClass]="{'live-code-input-button-animation': animatedButton == '1'}"
        (click)="activateAnimation('1');guessNumber = (guessNumber + '1').slice(0,12)">1</div>
    <div class="live-code-input-button" [ngClass]="{'live-code-input-button-animation': animatedButton == '2'}"
        (click)="activateAnimation('2');guessNumber = (guessNumber + '2').slice(0,12)">2</div>
    <div class="live-code-input-button" [ngClass]="{'live-code-input-button-animation': animatedButton == '3'}"
        (click)="activateAnimation('3');guessNumber = (guessNumber + '3').slice(0,12)">3</div>
    <div class="live-code-input-button" [ngClass]="{'live-code-input-button-animation': animatedButton == '4'}"
        (click)="activateAnimation('4');guessNumber = (guessNumber + '4').slice(0,12)">4</div>
    <div class="live-code-input-button" [ngClass]="{'live-code-input-button-animation': animatedButton == '5'}"
        (click)="activateAnimation('5');guessNumber = (guessNumber + '5').slice(0,12)">5</div>
    <div class="live-code-input-button" [ngClass]="{'live-code-input-button-animation': animatedButton == '6'}"
        (click)="activateAnimation('6');guessNumber = (guessNumber + '6').slice(0,12)">6</div>
    <div class="live-code-input-button" [ngClass]="{'live-code-input-button-animation': animatedButton == '7'}"
        (click)="activateAnimation('7');guessNumber = (guessNumber + '7').slice(0,12)">7</div>
    <div class="live-code-input-button" [ngClass]="{'live-code-input-button-animation': animatedButton == '8'}"
        (click)="activateAnimation('8');guessNumber = (guessNumber + '8').slice(0,12)">8</div>
    <div class="live-code-input-button" [ngClass]="{'live-code-input-button-animation': animatedButton == '9'}"
        (click)="activateAnimation('9');guessNumber = (guessNumber + '9').slice(0,12)">9</div>
    <div class="live-code-input-button" [ngClass]="{'live-code-input-button-animation': animatedButton == 'T'}"
        (click)="activateAnimation('T');guessNumber = guessNumber.slice(0,guessNumber.length-1)"><svg fill="white"
            class="h-[30px]" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.-->
            <path
                d="M576 192C576 156.7 547.3 128 512 128L205.3 128C188.3 128 172 134.7 160 146.7L9.4 297.4C3.4 303.4 0 311.5 0 320C0 328.5 3.4 336.6 9.4 342.6L160 493.3C172 505.3 188.3 512 205.3 512L512 512C547.3 512 576 483.3 576 448L576 192zM284.1 252.1C293.5 242.7 308.7 242.7 318 252.1L351.9 286L385.8 252.1C395.2 242.7 410.4 242.7 419.7 252.1C429 261.5 429.1 276.7 419.7 286L385.8 319.9L419.7 353.8C429.1 363.2 429.1 378.4 419.7 387.7C410.3 397 395.1 397.1 385.8 387.7L351.9 353.8L318 387.7C308.6 397.1 293.4 397.1 284.1 387.7C274.8 378.3 274.7 363.1 284.1 353.8L318 319.9L284.1 286C274.7 276.6 274.7 261.4 284.1 252.1z" />
        </svg></div>
    <div class="live-code-input-button" [ngClass]="{'live-code-input-button-animation': animatedButton == '0'}"
        (click)="activateAnimation('0');guessNumber = (guessNumber + '0').slice(0,12)">0</div>
    <div class="live-code-input-button" [ngClass]="{'live-code-input-button-animation': animatedButton == 'N'}"
        (click)="activateAnimation('N');guessNumber.includes('.')?null: guessNumber = (guessNumber + '.').slice(0,12)">.
    </div>
    <div [ngClass]="{'hidden': !guessNumber}" (click)="sendAnswer(guessNumber)"
        class="mt-2 text-center w-[90vw] mx-auto py-0.5 border-[2px] border-white rounded-full text-white text-[20px] font-semibold">
        {{t('modal.confirm')}}</div>
</div>
}
@if(currentType == 5 && !quizEnded){}
@if(currentType == 6 && !quizEnded){}
@if(currentType == 7 && !quizEnded){}
<!-- @if(quizEnded){
<div class="pt-10 text-center text-[32px] text-white font-bold">{{t('quizEnded')}}</div>
} -->
}@else{
<div class="h-[calc(100dvh-75px)] overflow-y-scroll overflow-x-hidden">
    <div class="py-10">
        <img class="w-[70vw] animation-start-quiz-logo mx-auto" src="./assets/logo.png">
    </div>
    <div class="text-white text-[32px] font-bold text-center px-5">{{t('insertGameCode')}}</div>
    <input [(ngModel)]="newliveId" (keyup)="changeCode($event,t)"
        class="w-[calc(100%-20px)] text-[90px] ml-2.5 h-[150px] font-semibold rounded-lg bg-blue-200 mt-2.5 text-center"
        type="number">

</div>
}
<div class="w-screen fixed bottom-0 left-0">
    <div class="w-full h-[60px] bg-gray-800 flex place-content-between items-center px-2">
        <!-- <div class="">😀</div> -->
        <!-- <div>{{t('points')}}: {{points}}</div> -->
        <div (click)="showUserProfile = true" class="border-white h-[50px] cursor-pointer border-2 rounded-full flex gap-5 pl-1.5 pr-[14px] items-center" [ngClass]="{'opacity-0': !user?.nickname}">
            <div class="text-[28px]">{{user?.profile_icon}}</div>
            <div class="text-white font-bold text-[18px]">{{user?.nickname}}</div>
        </div>
        <div class="flex items-end h-[50px]" [ngClass]="{'pointer-events-none opacity-35': blockEmoji || !socket}">
            <std-click-outside (clickOutside)="isEmojiOpen ?openEmojiList() : null">
                <div (click)="!isEmojiOpen ?openEmojiList() : null" id="emoji-reaction"
                    class="rounded-full mx-auto flex gap-3 px-2 py-1 overflow-y-hidden overflow-x-hidden hide-bar h-[50px] cursor-pointer place-content-start items-center w-[150px] bg-black overflow-hidden">
                    @for (emoji of emojiList; track $index) {
                    <div [ngClass]="{'pointer-events-none': !isEmojiOpen}"
                        (click)="$event.stopPropagation();isEmojiOpen ? sendEmoji(emoji) : null"
                        class="w-fit mx-auto text-[26px]">{{emoji}}</div>
                    }
                </div>
            </std-click-outside>
        </div>
    </div>
</div>
@if(showModalExitLive){
<std-modal [show]="showModalExitLive" (close)="showModalExitLive = false">
    <div header class="text-white text-[18px] font-medium">{{t('leaveLastSession')}}</div>
    <div content>{{t('leaveLastSessionAlert')}}

        <div class="flex gap-5 mt-5">
            <div class="w-[calc(50%-10px)]"><std-button
                    (click)="showModalExitLive = false">{{t('modal.cancel')}}</std-button></div>
            <div class="w-[calc(50%-10px)]"><std-button (click)="exitLastLive()">{{t('modal.confirm')}}</std-button>
            </div>
        </div>
    </div>

</std-modal>
}
@if(showModalLogin){
<std-modal closeClass="hidden" [show]="showModalLogin" [closeOnOutside]="false">

    <div header class="w-[80vw] text-white font-bold">{{t('auth.login')}}</div>
    <div content>

        <div class="w-full"><std-input labelPosition="top" customInputClass="custom-input" customLabel="label-input"
                [label]="t('auth.email')" [placeholder]="t('auth.email')" customContainerlass="mb-2" [(ngModel)]="email"
                [value]="email" id="email-login" type="email">
            </std-input>
            <std-input labelPosition="top" customInputClass="custom-input" customLabel="label-input"
                [label]="t('auth.password')" [placeholder]="t('auth.password')" [(ngModel)]="password"
                id="password-login" [type]="showPassword ? 'text':'password'" [value]="password">
            </std-input>
            <div (click)="showModalRecovery = true;showModalLogin = false"
                class="text-[#2D2D2D] cursor-pointer w-fit text-[12px] opacity-50 mt-[10px] ml-auto">
                {{t('auth.forgetPassword')}}</div>
        </div>
        <div class="ml-auto w-full mt-5">
            <std-button (click)="login(t)" id="button-login" size="sm"
                buttonClass="uppercase bg-primary hover:bg-primary focus:bg-primary">{{t('auth.enter')}}</std-button>
            <div class="text-[#2D2D2D] w-fit mx-auto text-[12px] opacity-50 mt-[10px]">
                {{t('or')}}</div>
            <std-button (click)="showModalRegister = true;showModalLogin = false" id="button-login" size="sm"
                buttonClass="uppercase bg-white hover:bg-white !text-primary shadow-xl focus:bg-white mt-2">{{t('auth.register')}}</std-button>
        </div>


    </div>
</std-modal>
}

@if(showModalRecovery){
<std-modal [show]="showModalRecovery" (close)="showModalRecovery = false;showModalLogin = true" [closeOnOutside]="false">

    <div header class="w-[80vw] text-white font-bold">{{t('auth.login')}}</div>
    <div content>

        <div class="w-full"><std-input labelPosition="top" customInputClass="custom-input" customLabel="label-input"
                [label]="t('auth.email')" [placeholder]="t('auth.email')" customContainerlass="mb-2" [(ngModel)]="email"
                [value]="email" id="email-login" type="email">
            </std-input>
        </div>
        <div class="ml-auto w-full mt-5">
            <std-button (click)="sendEmail(t)" id="button-login" size="sm"
                buttonClass="uppercase bg-primary hover:bg-primary focus:bg-primary">{{t('auth.sendRecoveryEmail')}}</std-button>
        </div>


    </div>
</std-modal>
}

@if(showModalRegister){
<std-modal [show]="showModalRegister" (close)="showModalRegister = false;showModalLogin = true">

    <div header class="w-[80vw] text-white font-bold">{{t('auth.register')}}</div>
    <div content>
        <div class="">
            <div class="md:flex flex-wrap gap-[20px] place-content-center">

                <!-- <std-input customInputClass="custom-input" customLabel="label-input" [placeholder]="t('name') + '*'"
                customContainerlass="!w-full border-b-[2px] border-primary mb-8"
                customInputClass="border-0 rounded-none" [(ngModel)]="credentials.firstName"
                [value]="credentials.firstName" id="name-login">
            </std-input>
            <std-input customInputClass="custom-input" customLabel="label-input" [placeholder]="t('lastName')+ '*'"
                customContainerlass="!w-full border-b-[2px] border-primary mb-8"
                customInputClass="border-0 rounded-none" [(ngModel)]="credentials.lastName"
                [value]="credentials.lastName" id="lastName-login"></std-input> -->
                <std-input [ngClass]="{'absolute-red-error': emailAlreadyUsed}" customInputClass="custom-input"
                    customLabel="label-input" [placeholder]="t('auth.email')+ '*'"
                    customContainerlass="!w-full border-b-[2px] border-primary mb-2"
                    customInputClass="border-0 rounded-none" [(ngModel)]="credentials.email"
                    (ngModelChange)="checkEmail(t)" [value]="credentials.email">

                </std-input>
                @if(messageEmail() && !emailAlreadyUsed){
                <div class="text-red-500" [ngClass]="{'!text-green-500':messageEmail() == 'theEmailIsValid'}">
                    {{t(messageEmail())}}</div>
                }
                <std-input [ngClass]="{'absolute-red-error': nickAlreadyUsed}" customInputClass="custom-input"
                    customLabel="label-input" [placeholder]="t('nickname')"
                    customContainerlass="!w-full border-b-[2px] border-primary my-8"
                    customInputClass="border-0 rounded-none" [(ngModel)]="credentials.nickname"
                    (ngModelChange)="checkNickname(t)" [value]="credentials.nickname">
                </std-input>
                <div class="flex" (click)="showBirth()">
                    <input (click)="$event.stopPropagation()" id="birth-date-registration" class="w-0" type="date"
                        [(ngModel)]="credentials.birth_date" [value]="credentials.birth_date">
                    <std-input class="pointer-events-none w-full" customInputClass="custom-input"
                        customLabel="label-input" [placeholder]="t('birthDate')"
                        customContainerlass="!w-full border-b-[2px] border-primary mb-8"
                        customInputClass="border-0 rounded-none" [(ngModel)]="credentials.birth_date"
                        [value]="credentials.birth_date" type="text">
                    </std-input>
                </div>
                <std-input (keyup)="checkPassword()" customInputClass="custom-input" customLabel="label-input"
                    [placeholder]="t('auth.password')+ '*'"
                    customContainerlass="!w-full border-b-[2px] border-primary mb-2" customInputClass="border-0"
                    [(ngModel)]="credentials.password" id="password-login" [type]="showPassword ? 'text':'password'"
                    [value]="credentials.password">
                    <div iconRight class="flex place-content-center">
                        <img (touchstart)="showPassword = true" (touchend)="showPassword=false"
                            (mousedown)="showPassword = true" (mouseup)="showPassword=false" class="cursor-pointer"
                            src="../../assets/eye.svg">
                    </div>
                </std-input>
                @if(messagePassword){
                <div class="text-red-500" [ngClass]="{'!text-green-500':messagePassword == 'thePasswordIsSafe'}">
                    {{t(messagePassword)}}</div>
                }
                <std-input customInputClass="custom-input" customLabel="label-input"
                    [placeholder]="t('auth.confirmPassword')+ '*'"
                    customContainerlass="!w-full border-b-[2px] border-primary my-8" customInputClass="border-0"
                    [(ngModel)]="credentials.confirmPassword" id="confirm-password-login"
                    [type]="showPassword ? 'text':'password'" [value]="credentials.confirmPassword">
                    <div iconRight class="flex place-content-center">
                        <img (touchstart)="showPassword = true" (touchend)="showPassword=false"
                            (mousedown)="showPassword = true" (mouseup)="showPassword=false" class="cursor-pointer"
                            src="../../assets/eye.svg">
                    </div>
                </std-input>
                <div class="">
                    <div>{{t('chooseProfileIcon')}}</div>
                    <div class="flex gap-5 items-center h-[50px] border-black border-[2px] rounded-[14px] pl-2 pr-2">
                        <div class="w-[50px] text-[32px] border-r-black border-r-[2px] text-center">{{registerEmoji
                            ?registerEmoji : '?'}}</div>
                        <div class="w-[calc(100%-70px)] custom-scrollbar flex gap-2 overflow-x-scroll">
                            @for (emoji of emojiList; track $index) {
                            <div class="text-[25px] cursor-pointer" (click)="registerEmoji = emoji">{{emoji}}</div>
                            }
                        </div>
                    </div>
                </div>
                <div class="flex gap-4 text-medium items-center w-full"><std-checkbox borderTrue="var(--primary)"
                        backGroundTrue="var(--primary)" [isChecked]="acceptTerms" (onChange)="checkboxTerms($event)"
                        id="referral">
                    </std-checkbox>
                    <div>Prima di proseguire devi accettare i nostri <a class="font-bold text-primary underline"
                            target="_blank" href="example.com">termini e
                            condizioni</a></div>
                </div>

            </div>




        </div>
        <div class="mx-auto w-full">
            <div (click)="showModalLogin = true ; showModalRegister = false"
                class="text-[#2D2D2D] cursor-pointer w-fit text-[12px] opacity-50 mt-[10px] ml-auto">
                {{t('auth.backToLogin')}}</div>
            <div class="ml-auto w-full mt-5">
                <std-button (click)="checkCredentials(t)" id="button-login" size="sm"
                    buttonClass="uppercase bg-primary hover:bg-primary focus:bg-primary">{{t('auth.register')}}</std-button>
            </div>
        </div>


    </div>
</std-modal>
}
@if(showUserProfile){
<std-modal [show]="showUserProfile" (close)="showUserProfile = false">

    <div header class="w-[90vw] text-white font-bold">{{t('auth.profile')}}</div>
    <div content>
        <div class="">
            <div class="flex mb-5 px-2 items-center w-full place-content-between">
                <div class="cursor-pointer text-[22px] hover:!text-[24px] transition-all"
                    (click)="changeLang('it')">🇮🇹
                </div>
                <div class="cursor-pointer text-[22px] hover:!text-[24px] transition-all"
                    (click)="changeLang('en')">🇺🇸</div>
                <div class="cursor-pointer text-[22px] hover:!text-[24px] transition-all"
                    (click)="changeLang('de')">🇩🇪</div>
                <div class="cursor-pointer text-[22px] hover:!text-[24px] transition-all"
                    (click)="changeLang('es')">🇪🇸</div>
                <div class="cursor-pointer text-[22px] hover:!text-[24px] transition-all"
                    (click)="changeLang('fr')">🇫🇷</div>
            </div>
            <div>{{t('auth.changeProfileIcon')}}</div>
            <div class="flex gap-5 items-center h-[50px] border-black border-[2px] rounded-[14px] pl-2 pr-2">
                <div class="w-[50px] text-[32px] border-r-black border-r-[2px] text-center">{{user.profile_icon}}</div>
                <div class="w-[calc(100%-70px)] custom-scrollbar flex gap-2 overflow-x-scroll">
                    @for (emoji of emojiList; track $index) {
                    <div class="text-[25px] cursor-pointer" (click)="user.profile_icon = emoji;updateEmoji()">{{emoji}}</div>
                    }
                </div>
            </div>
        </div>
        <div class="mx-auto w-full gap-2">
            @if(this.liveId){<div class="ml-auto w-full mt-5">
                <std-button (click)="exitQuiz()" id="button-exit-live" size="sm"
                    buttonClass="uppercase bg-primary hover:bg-primary focus:bg-primary">{{t('exitLive')}}</std-button>
            </div>}
            <div class="ml-auto w-full mt-5">
                <std-button (click)="logout()" id="button-logout" size="sm"
                    buttonClass="uppercase bg-primary hover:bg-primary focus:bg-primary">{{t('auth.logout')}}</std-button>
            </div>
        </div>
    </div>
</std-modal>
}
</div>